// extracted by mini-css-extract-plugin
export default {"task-paragraph":"TaskItem_task-paragraph__PaofW"};